import "./inputs.scss";
import * as React from "react";
import { type InputHTMLAttributes } from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import FontAwesomeSolid from "../../Utilities/Platform/FontAwesome/FontAwesomeSolid";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    loading?: boolean;
    clearable: boolean;
    onClear: (e: React.MouseEvent<HTMLDivElement>) => void;
    inputRef?: React.RefObject<HTMLInputElement | null>;
}

export default class ClearableInput extends React.Component<Props> {
    public static defaultProps = {
        clearable: true,
    };

    public render(): React.ReactNode {
        const { onClear, value, clearable, loading, className, inputRef, ...props } = this.props;
        const hasValue = !!value;

        return (
            <div className={"clearable-input-wrapper" + (loading ? " loading" : "") + (hasValue ? " clearable" : "")}>
                <input
                    className={"clearable-input" + (className ? ` ${className}` : "")}
                    ref={inputRef}
                    value={value}
                    {...props}
                />
                {loading && (
                    <div className="clearable-input-loading">
                        <FontAwesomeLight icon="spinner-third" spin />
                    </div>
                )}
                {(hasValue && clearable) && (
                    <div className="clearable-input-clear" onClick={onClear}>
                        <FontAwesomeSolid icon="times-circle" />
                    </div>
                )}
            </div>
        );
    }
}
